"use client";

import { useEffect } from "react";

import styles from "./InterstitialModal.module.css";

export default function InterstitialModal({
  slotId,
  onCloseAction,
  isVisible,
}: {
  slotId: string;
  onCloseAction: () => void;
  isVisible: boolean;
}) {
  const handleClose = () => {
    (document.activeElement as HTMLElement | null)?.blur();
    onCloseAction();
  };

  useEffect(() => {
    if (!isVisible) return undefined;

    const previousOverflow = document.body.style.overflow;
    const previousOverscroll = document.body.style.overscrollBehavior;

    document.body.style.overflow = "hidden";
    document.body.style.overscrollBehavior = "contain";

    return () => {
      document.body.style.overflow = previousOverflow;
      document.body.style.overscrollBehavior = previousOverscroll;
    };
  }, [isVisible]);

  return (
    <div
      className={isVisible ? styles.backdrop : styles.backdropHidden}
      role="dialog"
      aria-modal="true"
      aria-label="Advertisement"
      aria-hidden={!isVisible}
    >
      <div className={styles.shell}>
        <span className={styles.label}>Advertisement</span>

        <button
          className={styles.closeButton}
          type="button"
          onClick={handleClose}
          aria-label="Close ad"
          tabIndex={isVisible ? 0 : -1}
        >
          ×
        </button>

        <div id={slotId} className={styles.slot} />
      </div>
    </div>
  );
}
